module.exports = __webpack_public_path__ + "img/J.9110a0f5.png";